import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders an input field for the ZIP code.
 **/
export const TextFieldZip = ({ values, handleChange, errors, touched }) => (
    <TextField
        fullWidth
        label={t('users.fields.postalCode')}
        name="zip"
        value={values.zip}
        error={touched.zip && Boolean(errors.zip)}
        helperText={touched.zip && errors.zip}
        onChange={(event) => {
            const inputValue = event.target.value;
            const formattedValue = inputValue.replace(/[^0-9]/g, '').slice(0, 7);
            const formattedWithDash =
                formattedValue.slice(0, 4) +
                (formattedValue.length > 4 ? '-' : '') +
                formattedValue.slice(4);
            handleChange({
                target: { name: 'zip', value: formattedWithDash }
            });
        }}
    />
);

TextFieldZip.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
